import OperatorService from "@/api/services/operator.service";

const SipServersService = {
  getList(params = { search: "", page: 1, count: 10 }) {
    return OperatorService.get(`/sip-servers`, { headers: params });
  },

  getListSelect() {
    return OperatorService.get(`/sip-servers_list`);
  },
  get(id_sip_server) {
    return OperatorService.get(`/sip-servers/${id_sip_server}`);
  },

  update(id_sip_server, newSipServer) {
    return OperatorService.put(`/sip-servers/${id_sip_server}`, newSipServer);
  },

  create(sip_server) {
    return OperatorService.post(`/sip-servers`, sip_server);
  },

  delete(id_sip_server) {
    return OperatorService.delete(`/sip-servers/${id_sip_server}`);
  },
};

export default SipServersService;
